import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import Loader from 'Components/Atoms/Loader/Loader';
import Text from 'Components/Atoms/Text/Text';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RelationService } from 'Services/Relation/Application/RelationService';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { getFieldsAsObject } from 'Store/Settings/Fields/Selectors';
import styles from './CombinationField.module.sass';

const CombinationField = ({
    fields,
    isEdit, value, fieldProperties, onChange
}) => {
    const [activeTab, setActiveTab] = useState(0);

    const [state, setState] = useState({
        isRelationFetching: false
    });

    const newValueArray = (v: any) => Array.isArray(value) ? [...value] : [{title: 'Optie 1'}];

    useEffect(() => {
        if (!isEdit) setActiveTab(0);
    }, [isEdit]);

    const handleAddClick = () => {
        onChange([...(value || []), { title: `Optie ${(value || []).length+1}` }]);
    }
    const handleDeleteClick = (i: number) => {
        setActiveTab(0);
        const newValues = newValueArray(value);
        newValues.splice(i, 1);
        onChange(newValues);
    }

    const handleRelationChange = async (currentIteration, maxIteration, values) => {
        const fieldId = fieldProperties?.fields[currentIteration];
        const aboveRelationValues = values[activeTab]?.[fieldId];

        const underFieldId = fieldProperties?.fields[currentIteration+1];
        const underFieldValues = [...(values[activeTab]?.[underFieldId] || [])];

        let newUnderFieldValues: any = [];
        if (aboveRelationValues && aboveRelationValues?.length > 0) {
            const relationService = new RelationService();
            const relationValues = await relationService.fetchRelations(aboveRelationValues);

            newUnderFieldValues = underFieldValues.filter(i => relationValues.includes(i));
        }

        values[activeTab] = {
            ...values[activeTab],
            [underFieldId]: newUnderFieldValues
        };

        if (currentIteration == maxIteration) {
            setState({...state, isRelationFetching: false});
            onChange(values);
            
            return;
        }

        handleRelationChange(currentIteration+1, maxIteration, [...values]);
        setState({...state, isRelationFetching: false});
    }

    const handleChange = (idx, fieldId, inputValue) => {
        const newValues = newValueArray(value);
        newValues[activeTab] = {
            ...newValues[activeTab],
            [fieldId]: inputValue
        }

        const fieldLength = fieldProperties?.fields?.length-1;
        if (idx < fieldLength) {
            setState({...state, isRelationFetching: true});

            handleRelationChange(idx, fieldLength, newValues);

            return;
        }

        onChange(newValues);
    }

    if (!fields) {
        return <Loader size='small' />
    }

    return <div className={styles['combination']}>
        { 
            fieldProperties?.multi &&
            <div className={styles['combination__header']}>
                {
                    Array.isArray(value) && value.map((item: any, index: number) => {
                        return <div className={`${styles['combination__header-item']} ${index == activeTab ? styles['active'] : ''}`} key={index}>
                            <span onClick={() => setActiveTab(index)}>{ item?.title }</span>
                            {
                                isEdit && value.length != 1 && <div onClick={() => handleDeleteClick(index)} className={styles['combination__header-item-close']}>
                                    <Icon type={ICONS.CLOSE} size={'small'}/>
                                </div>
                            }
                        </div>
                    })
                }
                {
                    isEdit && <div className={`${styles['combination__header-item']} ${styles['combination__header-item--add']}`} onClick={handleAddClick}>
                        <span>+ Toevoegen</span>
                    </div>
                }
            </div>
        }
        <div className={styles['combination__content']}>
            {
                fieldProperties?.multi
                && isEdit
                && <div className={styles['combination__content-item']}>
                    <div className={styles['combination__content-item--header']}><Text>Titel</Text></div>
                    <div className={styles['combination__content-content-item']}>
                        <Field
                            isEdit={true}
                            value={value && value[activeTab]?.title}
                            type={FieldType.Text}
                            required={false}
                            onChange={(e: any) => handleChange(fieldProperties?.fields?.length, 'title', e)}
                        />
                    </div>
                </div>
            }
            {
                fieldProperties?.fields.map((fieldId: any, index: number) => {
                    const aboveFieldId = fieldProperties?.fields[index-1];
                    const isDisabled = !(value?.[activeTab]?.[aboveFieldId] && value?.[activeTab]?.[aboveFieldId]?.length > 0);
                    const field = fields?.[fieldId];

                    let relation = [];
                    if (aboveFieldId) {
                        const aboveField = fields?.[fieldId];
                        const isDatasetField = aboveField?.type === FieldType.Multi_Selector || aboveField?.type === FieldType.Dropdown;
                        const relationValue = value?.[activeTab]?.[aboveFieldId];
                        
                        if (isDatasetField && relationValue) {
                            relation = relationValue;
                        }
                    }

                    return <div className={styles['combination__content-item']}>
                        <div className={styles['combination__content-item--header']}><Text>{ field?.name }</Text></div>
                        <div className={styles['combination__content-item--content']}>
                            <Field
                                isEdit={isEdit}
                                value={value && value[activeTab] && value[activeTab][fieldId]}
                                type={field.type}
                                required={false}
                                onChange={(v: any) => handleChange(index, fieldId, v)}
                                fieldProperties={{
                                    ...field.default,
                                    isDisabled: index === 0
                                        ? false
                                        : isDisabled,
                                    inRelation: relation
                                }}
                                alignLeft
                            />
                        </div>
                    </div>;
                })
            }
        </div>
    </div>;
};

export default connect(
    (state: any, props: any) => ({
        // fields: getAllFieldsByEntity(state, props.fieldProperties?.entity),
        fields: getFieldsAsObject(state)
    }),
    {}
)(CombinationField);